var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pick-card",class:_vm.cardClass,on:{"click":_vm.handleCardClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }